import * as React from 'react';
import {Alert, Col, InputGroup, Modal} from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import {Action} from './buttons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import PulsoidClient from '../PulsoidClient';

export class UpdateChannelModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {channel: ''};
  }

  close = () => {
    this.setState({channel: '', error: undefined});
    this.props.onClose();
  };

  render() {
    return (
      <Modal show={this.props.show} onHide={this.close} centered size={'lg'}>
        <Modal.Header closeButton>
          <Modal.Title>Update your channel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant={'success'}>
            Note! Use well-formed url like{' '}
            <bold>https://twitch.tv/channel_name</bold>. Supported platforms :
            Twitch
          </Alert>
          <Form.Group as={Row}>
            <Form.Label column>Channel url</Form.Label>
            <Col sm="7">
              <Form.Control
                value={this.state.channel}
                isInvalid={this.state.error}
                onChange={(e) =>
                  this.setState({channel: e.target.value, error: undefined})
                }
              />
            </Col>
          </Form.Group>
          {this.state.error && (
            <Alert variant={'danger'}>{this.state.error}</Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Action onClick={this.handleUpdate}>Update</Action>
        </Modal.Footer>
      </Modal>
    );
  }

  componentWillUnmount() {
    this.setState({channel: '', error: undefined});
  }

  handleUpdate = () => {
    let channel = this.state.channel.trim();
    if (channel.length === 0) {
      this.setState({error: 'Channel is empty.'});
      return;
    }

    if (
      !['twitch', 'youtube'].find((platform) =>
        channel.toLocaleLowerCase().includes(platform)
      )
    ) {
      this.setState({error: 'Channel streaming platform is not supported.'});
      return;
    }

    if (channel.charAt(channel.length - 1) === '/') {
      channel = channel.substring(0, channel.length - 1);
      return;
    }

    let segments = channel.split('/');
    if (segments.length < 2) {
      this.setState({error: 'Bad url.'});
      return;
    }

    this.props.onUpdate(channel);
  };
}

export class UpdateChanelInput extends React.Component {
  pulsoid = new PulsoidClient();
  state = {
    showModal: false,
  };

  componentDidMount() {
    this.pulsoid.getUserInfo().then((profile) => this.setState({profile}));
  }

  render() {
    let channel = 'Loading...';

    if (this.state.profile) {
      if (this.state.profile.channel) {
        channel = this.state.profile.channel.url;
      } else {
        channel = '';
      }
    }

    return (
      <>
        <Col sm={'3'} onClick={(_) => this.setState({showModal: true})}>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Prepend>
                <InputGroup.Text>
                  {' '}
                  <FontAwesomeIcon icon={faPencilAlt} />
                </InputGroup.Text>
              </InputGroup.Prepend>
            </InputGroup.Prepend>
            <Form.Control readOnly value={channel} />
          </InputGroup>
        </Col>
        <UpdateChannelModal
          show={this.state.showModal}
          onClose={() => {
            this.setState({showModal: false});
          }}
          onUpdate={(channel) =>
            (async () => {
              await new PulsoidClient().updateChannel(channel);
              await this.pulsoid
                .getUserInfo()
                .then((profile) => this.setState({profile}));
              this.setState({showModal: false});
            })()
          }
        />
      </>
    );
  }
}
